import {
    FETCH_HL7_SENT_MESSAGES_START, FETCH_HL7_SENT_MESSAGES_SUCCESS, FETCH_HL7_SENT_MESSAGES_ERROR, RESEND_HL7_SENT_MESSAGE_START, RESEND_HL7_SENT_MESSAGE_ERROR, RESEND_HL7_SENT_MESSAGE_SUCCESS, SEARCH_HL7_SENT_MESSAGES, SEARCH_HL7_SENT_MESSAGES_ERROR, SEARCH_HL7_SENT_MESSAGES_START, SEARCH_HL7_SENT_MESSAGES_SUCCESS, SHOW_ACKNOWLEDGEMENT_MODAL, CLOSE_ACKNOWLEDGEMENT_MODAL
} from '../../actions/admin/hl7SentMessagesAction';

const INIT_STATE = {
    error: "",
    message: '',
    loading: false,
    sending: false,
    showModal: false,
    selectedRow: null,
    hl7SentMessages: [],
    pagination: {
        currentPage: 1,
        pageSize: 40,
        totalPages: 0,
        totalItems: 0,
    },
};

const hl7SentMessagesReducer = (state = INIT_STATE, action) => {
    let index;
    let newState;
    switch (action.type) {
        case FETCH_HL7_SENT_MESSAGES_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_HL7_SENT_MESSAGES_SUCCESS: {
            // return { ...state, error: '', message: '', loading: false, hl7OutLogs: action.hl7OutLogs };
            return { 
                ...state, 
                error: '', 
                message: '', 
                loading: false, 
                hl7SentMessages: action.data.hl7SentMessages,
                pagination: action.data.pagination
            };
        }
        case FETCH_HL7_SENT_MESSAGES_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case RESEND_HL7_SENT_MESSAGE_START: {
            return { ...state, error: '', message: '', sending: true };
        }
        case RESEND_HL7_SENT_MESSAGE_SUCCESS: {
            let newHl7SentMessages = [...state.hl7SentMessages];
            index = newHl7SentMessages.findIndex(log => log.messageControlId === action.data.messageControlId);
            if (index > -1) {
                newHl7SentMessages.splice(index, 1, { ...newHl7SentMessages[index], ...action.data, reportSentSuccess:true });
            }
            return { ...state, error: '', message: '', sending: false, hl7SentMessages: newHl7SentMessages };
        }
        case RESEND_HL7_SENT_MESSAGE_ERROR: {
            return { ...state, message: '', error: action.error, sending: false };
        }
        case SEARCH_HL7_SENT_MESSAGES_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case SEARCH_HL7_SENT_MESSAGES_SUCCESS:
        {
            return { 
                ...state, 
                error: '', 
                message: '', 
                loading: false, 
                hl7SentMessages: action.data.searchhl7SentMessages,
                pagination: action.data.pagination
            };
        }
        case SEARCH_HL7_SENT_MESSAGES_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case SHOW_ACKNOWLEDGEMENT_MODAL: {
            return { ...state, showModal: true, selectedRow: action.selectedRow };
        }
        case CLOSE_ACKNOWLEDGEMENT_MODAL: {
            return { ...state, showModal: false, selectedRow: null };
        }
        default:
            return state;
    }
}

export default hl7SentMessagesReducer;
